import { compact } from 'lodash-es'
import { mapGetters } from 'vuex'
import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'
import APP_GETTERS from '@/js/plugins/store/modules/app/getter-types.js'
import { DP_PERM, DP_ROLE } from '@/js/helper/dp-usermanagement-constants'
import { scopes } from '@/js/helper/settings-filter.js'

export default {
  data() {
    return {
      ROLES: DP_ROLE,
      PERMS: DP_PERM,
    }
  },
  computed: {
    ...mapGetters(STOREMODULES.APP, {
      hasRole: APP_GETTERS.HAS_ROLE,
    }),
    hasMyRole() {
      return this.myRole ? this.hasRole(this.myRole) : true
    },
  },
  methods: {
    getAvailableScopes() {
      return compact(
        Object.entries(scopes).map(([scope, perm]) => (this.hasRole(perm) ? scope : undefined)),
      )
    },
  },
}
